import { render, staticRenderFns } from "./JobItemActivityList.vue?vue&type=template&id=36206e64&scoped=true"
import script from "./JobItemActivityList.vue?vue&type=script&lang=ts"
export * from "./JobItemActivityList.vue?vue&type=script&lang=ts"
import style0 from "./JobItemActivityList.vue?vue&type=style&index=0&id=36206e64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36206e64",
  null
  
)

export default component.exports